import { GridComparatorFn } from "@mui/x-data-grid";
import { DateTime } from "luxon";

type RowWithPickUpAndHotel = { pickUp?: string | null; hotel?: string | null };

/** ISO datetime / "HH:mm" -> millis; anything else falls back to the raw string. */
function toSortable(value: unknown): number | string {
    if (typeof value !== "string" || value.trim() === "") return "";
    const dt = DateTime.fromISO(value);
    return dt.isValid ? dt.toMillis() : value;
}

function comparePickUp(a: number | string, b: number | string): number {
    if (a === b) return 0;
    if (typeof a === "number" && typeof b === "number") return a - b;
    return String(a).localeCompare(String(b));
}

/**
 * Sorts by `pickUp`; rows with the same pick-up time are grouped by `hotel`
 * so passengers of the same hotel are not scattered across the table.
 */
export const pickUpThenHotelComparator: GridComparatorFn = (v1, v2, cellParams1, cellParams2) => {
    const byPickUp = comparePickUp(toSortable(v1), toSortable(v2));
    if (byPickUp !== 0) return byPickUp;

    const row1 = cellParams1.api.getRow(cellParams1.id) as RowWithPickUpAndHotel | null;
    const row2 = cellParams2.api.getRow(cellParams2.id) as RowWithPickUpAndHotel | null;
    return (row1?.hotel ?? "").localeCompare(row2?.hotel ?? "", "tr");
};
